import React from 'react';
import styles from './update-status.module.css'; // adjust if using separate style file

const UpdateStatus = ({
    selectedApplication,
    status,
    rejectionReasons,
    handleStatusChange,
    handleRejectionReasonsChange,
    handleSaveRejectionReasons,
    handleClose,
}) => {
    if (!selectedApplication) return null;

    return (
        <div className={styles.statusWrapper}>
        <div className={styles.statusUpdateContainer}>
            <h3>Update Status for {selectedApplication.name}</h3>
            <button onClick={handleClose} className={styles.closeButton}>x</button>
            <label>
                Status:
                <select value={status} onChange={handleStatusChange}>
                    <option value="accepted">Accepted</option>
                    <option value="not reviewed">Not Reviewed</option>
                    <option value="nextSteps Shortlisted">Next Steps Shortlisted</option>
                    <option value="not up to snuff">Not Up to Snuff</option>
                </select>
            </label>
            {status === 'not up to snuff' && (
                <div>
                    <label>
                        Rejection Reasons:
                        <select multiple value={rejectionReasons} onChange={handleRejectionReasonsChange}>
                            <option value="position filled">Position Filled</option>
                            <option value="requestMessage">Request Message</option>
                            <option value="socialPoints">Social Points</option>
                            <option value="Differentgender">Different Gender</option>
                            <option value="other">Other</option>
                            <option value="overqualified">Overqualified</option>
                            <option value="project Counts">Project Counts</option>
                        </select>
                    </label>
                    <button onClick={handleSaveRejectionReasons}>Save Rejection Reasons</button>
                </div>
            )}
        </div>
    </div>
    );
};

export default UpdateStatus;
